import * as tslib_1 from "tslib";
import { connectedAccountsStore } from '../store/store';
import { setConsumerMailbox } from '../services/setConsumerMailbox';
import { updateSessionSettings } from '../actions/defaultFrom/updateSessionSettings';
import { markIsConnectedAccountsDirty } from '../actions/connectedFull/markIsConnectedAccountsDirty';
import { markIsDefaultFromDirty } from '../actions/connectedFull/markIsDefaultFromDirty';
import { removeSyncRequest } from '../services/removeSyncRequest';
import { initConnectedAccountsFull } from '../orchestrators/initConnectedAccountsFull';
export function onSaveConnectedAccountOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store, index, found, _i, _a, account;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    store = connectedAccountsStore();
                    if (!store.isDefaultFromDirty) return [3 /*break*/, 2];
                    return [4 /*yield*/, setConsumerMailbox(store.defaultFromState.defaultFromAddress)];
                case 1:
                    _b.sent();
                    updateSessionSettings(store.defaultFromState.defaultFromAddress);
                    markIsDefaultFromDirty(false);
                    _b.label = 2;
                case 2:
                    if (!store.isConnectedAccountsDirty) return [3 /*break*/, 8];
                    index = 0;
                    index = 0;
                    _b.label = 3;
                case 3:
                    if (!(index < store.accountsInfo.SyncRequests.length)) return [3 /*break*/, 6];
                    found = false;
                    for (_i = 0, _a = store.accounts; _i < _a.length; _i++) {
                        account = _a[_i];
                        if (store.accountsInfo.SyncRequests[index].Id === account.syncRequest.Id) {
                            found = true;
                        }
                    }
                    if (!!found) return [3 /*break*/, 5];
                    return [4 /*yield*/, removeSyncRequest(store.accountsInfo.SyncRequests[index])];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5:
                    index++;
                    return [3 /*break*/, 3];
                case 6: return [4 /*yield*/, initConnectedAccountsFull()];
                case 7:
                    _b.sent();
                    markIsConnectedAccountsDirty(false);
                    _b.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=onSaveConnectedAccountOption.js.map